export enum Path {
  Home = "/",
  AboutUs = "/about-us",
  CookiesPolicy = "/cookies-policy",

  /**
   * FAQS
   */
  Faq = "/faqs",
  AboutFaq = "/about-faqs",
  ManageAccountFaq = "/manage-account-faqs",
  SendMoneyFaq = "/sendmoney-faqs",
  ReferralFaq = "/referral-faqs",

  PrivacyPolicy = "/privacy-policy",
  SendMoney = "/send-money",
  TermsAndConditions = "/terms-and-conditions",
  Blog = "/blog",
  Connect = "/connect",
  Business = "/business",
  License = "/remittance-product",
  LicensesAndCompliance = "/licenses",
  UsLicense = "/us/license-as-a-service",
  ConnectMarketPlace = "/connect/marketplace",
  Newsletter = "/newsletter",
  ModulrTermsAndConditions = "/modulr-terms-and-conditions",
  Otc = "/otc",
  ContactSales = "/contact-sales#africa",
  ContactSalesRemittance = "/contact-sales#diaspora",
  NotFound = "/404",
  DettyDecember = "/detty-december-promo",
  Waitlist = "/wait-list",
  WaitlistSuccess = "/wait-list-success",
  StateComplaintDisclosures = "/state-complaint-disclosures",
}
